import styled from 'styled-components';
import LS from '../styles/layoutStyled'
import CS from '../styles/componentStyled'
import AlarmModal2SizeDown from './AlarmModal2SizeDown';
import AlarmModal3 from './AlarmModal3';
import React, {useState, useRef, useMemo, useEffect} from 'react';
import DaumPostcode from 'react-daum-postcode';
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import { accessTokenState, refreshTokenState, expireState } from '../atom/TokenAtom';
import { alarmModal1Text } from '../atom/ModalAtom';
import { ApiService } from '../api';
import { loadingSpinnerState } from '../atom/ModalAtom';
import Papa from 'papaparse';
import { AssociationDto, AssociationsRequest } from '../model/association.dto';

interface MemberExcelModalProps {
    onClose: () => void;
}

const MemberExcelModal = ({ onClose }: MemberExcelModalProps) => {
    const setAlarmText = useSetRecoilState(alarmModal1Text);
    const [loadingState, setLoadingState] = useRecoilState(loadingSpinnerState);
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [expire, setExpire] = useRecoilState(expireState);
    const api = useMemo(() => new ApiService(), []);

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const [fileName, setFileName] = useState('');
    const [file, setFile] = useState<File | null>(null);
    const [datas, setDatas] = useState<AssociationsRequest | null>();

    const handleFileUploadBtnClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setFileName(event.target.files[0].name);
            setFile(event.target.files[0]);
            parseCsv(event.target.files[0]);
        }
    };

    const parseCsv = (file: File) => {
        Papa.parse(file, {
            complete: (result) => {
                const rows = result.data as string[][];
                if (rows.length === 0) {
                    setAlarmText("빈 파일입니다.");
                    return;
                }

                const startRow = rows[0][0].includes('회원') ? 1 : 0;
                const parsedData = rows.slice(startRow).map((row) => ({
                    membership_number: row[0],
                    name: row[1],
                    association_name: row[2],
                    phone_number: row[3].startsWith('0') ? row[3] : '0' + row[3],
                    exp_date: row[4]
                }));
                const requestPayload: AssociationsRequest = {
                    list: parsedData
                };
                setDatas(requestPayload);
            },
            error: () => {
                setAlarmText("등록에 실패했습니다. csv파일을 확인해 주세요.");
            },
            encoding: "UTF-8"
        });
    }

    const handleSubmit: any = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!file || fileName === '') {
            setAlarmText("업로드된 파일이 없습니다.");
            return;
        }
        try {
            if (!accessToken) return;
            if (datas) {
                setLoadingState(true);
                await api.associationsAdd(accessToken, datas);
            }
            window.location.reload();
        }
        catch(err: any) {
            setLoadingState(false);
            setAlarmText("내용이 올바르지 않습니다.\n내용을 확인해 주세요.");
        }
    }

    return (
        <>
            <AlarmModal2SizeDown>
                <h2>Excel 등록</h2>
                <form onSubmit={handleSubmit}>
                    <ul className="input-area">
                        <li>
                            <ul>
                                <li>
                                    <h3>Excel<span>*</span></h3>
                                    <div className="input-btn-box">
                                        <CS.TextInputType1
                                            placeholder='파일명'
                                            type='text'
                                            value={fileName}
                                            readOnly={true}
                                            onClick={handleFileUploadBtnClick}
                                        />
                                        <CS.TextInputType1
                                            type='file'
                                            accept=".csv"
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                        />
                                        <CS.Btn4Type1
                                            type='button'
                                            onClick={handleFileUploadBtnClick}
                                        >
                                        파일 찾기
                                        </CS.Btn4Type1>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div className="btn-box">
                        <CS.Btn2Type2 type='button' onClick={onClose}>취소</CS.Btn2Type2>
                        <CS.Btn2Type1 type='submit'>확인</CS.Btn2Type1>
                    </div>
                </form>
            </AlarmModal2SizeDown>
        </>
    );

};

export default MemberExcelModal;
